import React from 'react';
import { createRoot } from 'react-dom/client';
import { legacy_createStore as createStore} from 'redux';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import rootReducer from './Reducers/rootReducer';
import { Messagemodals } from './Components/Productmodals';
import { Newconversationpage } from './Pages/Newconversationpage';

const store = createStore(rootReducer);


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
     <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Productmodals/Messagemodals
// Newconversationpage